const STICKY_SIDEBAR_CHECKOUT_OFFSET = 10;
const CART_REMOVAL_TOAST_SELECTOR = "[data-cart-removal-toast]";
const CART_REMOVAL_TOAST_VISIBLE_CLASS = "cart-removal-toast--visible";
const CART_REMOVAL_TOAST_LEAVING_CLASS = "cart-removal-toast--leaving";
const CART_REMOVAL_TOAST_DURATION = 3000;
const CART_REMOVAL_TOAST_EXIT_DURATION = 200;

function getAddonOnlyProductIds(
  cartItems = document.querySelector("cart-items"),
) {
  const rawIds = cartItems?.dataset?.addonOnlyProductIds;
  if (!rawIds) {
    return new Set();
  }

  return new Set(
    rawIds
      .split(",")
      .map((id) => Number.parseInt(id, 10))
      .filter(Number.isFinite),
  );
}

function getCartJsonUrl() {
  return `${window.Shopify.routes.root}cart.js`;
}

function parseHtml(html) {
  return new DOMParser().parseFromString(html, "text/html");
}

function refreshAffirmPromos() {
  const affirmUi = window.affirm?.ui;
  if (!affirmUi) {
    return;
  }

  if (typeof affirmUi.ready === "function") {
    affirmUi.ready(() => affirmUi.refresh?.());
    return;
  }

  affirmUi.refresh?.();
}

function getRemovedCartItemTitle(trigger) {
  const cartItem = trigger?.closest(".cart-item");
  const titleElement = cartItem?.querySelector(".cart-item-title");
  return titleElement?.textContent?.replace(/\s+/g, " ").trim() || "";
}

function getRemovedCartItemUrl(trigger) {
  const cartItem = trigger?.closest(".cart-item");
  const link = cartItem?.querySelector(".cart-item-title__link");
  return link?.getAttribute("href") || "";
}

function getCartRemovalToastTitle(cartItems) {
  return cartItems?.dataset?.cartRemovalToastTitle || "Item removed from cart";
}

function showCartRemovalToast(cartItems, itemTitle, itemUrl) {
  const existingToast = document.querySelector(CART_REMOVAL_TOAST_SELECTOR);
  existingToast?.remove();

  const toast = document.createElement("div");
  toast.className = "cart-removal-toast";
  toast.dataset.cartRemovalToast = "";
  toast.setAttribute("role", "status");
  toast.setAttribute("aria-live", "polite");

  const title = document.createElement("p");
  title.className = "cart-removal-toast__title";

  const icon = document.createElement("span");
  icon.className = "cart-removal-toast__icon";
  icon.setAttribute("aria-hidden", "true");
  icon.innerHTML =
    '<svg viewBox="0 0 16 16" focusable="false"><circle cx="8" cy="8" r="8" fill="currentColor"/><path d="M6.82 10.66 4.47 8.31l.94-.94 1.41 1.41 3.78-3.78.94.94-4.72 4.72Z" fill="#fff"/></svg>';

  const titleText = document.createElement("span");
  titleText.textContent = getCartRemovalToastTitle(cartItems);

  title.append(icon, titleText);
  toast.append(title);

  if (itemTitle) {
    const product = document.createElement("p");
    product.className = "cart-removal-toast__product";

    if (itemUrl) {
      const productLink = document.createElement("a");
      productLink.className = "cart-removal-toast__product-link";
      productLink.href = itemUrl;
      productLink.textContent = itemTitle;
      product.append(productLink);
    } else {
      product.textContent = itemTitle;
    }

    toast.append(product);
  }

  const closeButton = document.createElement("button");
  closeButton.className = "cart-removal-toast__close";
  closeButton.type = "button";
  closeButton.setAttribute(
    "aria-label",
    cartItems?.dataset?.cartRemovalToastDismissLabel ||
      "Dismiss item removed message",
  );
  closeButton.innerHTML =
    '<svg viewBox="0 0 12 12" focusable="false" aria-hidden="true"><path d="M1.41.59 6 5.17 10.59.59 11.41 1.41 6.83 6l4.58 4.59-.82.82L6 6.83l-4.59 4.58-.82-.82L5.17 6 .59 1.41l.82-.82Z" fill="currentColor"/></svg>';
  toast.append(closeButton);

  let dismissTimer;
  let removeTimer;
  const dismiss = () => {
    window.clearTimeout(dismissTimer);
    window.clearTimeout(removeTimer);

    toast.classList.add(CART_REMOVAL_TOAST_LEAVING_CLASS);
    removeTimer = window.setTimeout(
      () => toast.remove(),
      CART_REMOVAL_TOAST_EXIT_DURATION,
    );
  };

  closeButton.addEventListener("click", dismiss);
  document.body.append(toast);
  window.setTimeout(() =>
    toast.classList.add(CART_REMOVAL_TOAST_VISIBLE_CLASS),
  );
  dismissTimer = window.setTimeout(dismiss, CART_REMOVAL_TOAST_DURATION);
}

async function fetchText(url, options) {
  const response = await fetch(url, options);
  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }
  return response.text();
}

async function fetchJson(url, options) {
  const text = await fetchText(url, options);
  try {
    return JSON.parse(text);
  } catch (error) {
    throw new Error("Unable to parse JSON response");
  }
}

async function fetchCartState() {
  return fetchJson(getCartJsonUrl());
}

async function syncCartUi(cartItems, state) {
  if (!cartItems || !state) {
    return;
  }

  if (state.sections) {
    cartItems._applyCartSnapshot(state);
    return;
  }

  await cartItems.onCartUpdate({ cartData: state });
}

async function checkIfOnlyItemsLeftAreAddons(
  cartState = null,
  cartItems = document.querySelector("cart-items"),
) {
  if (!cartItems) {
    return;
  }

  const state = cartState || (await fetchCartState());
  const items = Array.isArray(state?.items) ? state.items : [];
  const addonOnlyProductIds = getAddonOnlyProductIds(cartItems);

  if (!items.length) return;
  if (!addonOnlyProductIds.size) {
    return;
  }

  const hasRealProduct = items.some(
    (item) => !addonOnlyProductIds.has(item.product_id),
  );
  if (hasRealProduct) {
    return;
  }

  const clearedCart = await cartItems._sendCartRequest("/cart/clear.js");
  await syncCartUi(cartItems, clearedCart);
}
document.addEventListener("DOMContentLoaded", () => {
  const cartItems = document.querySelector("cart-items");
  if (!cartItems || cartItems.classList.contains("is-empty")) {
    return;
  }
  checkIfOnlyItemsLeftAreAddons(null, cartItems).catch((error) => {
    console.error("Error clearing addon-only cart:", error);
  });
});
if (!customElements.get("cart-remove-button")) {
  class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener("click", this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
    }

    async handleClick(event) {
      event.preventDefault();

      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      if (!cartItems) {
        return;
      }

      const removedItemTitle = getRemovedCartItemTitle(this);
      const removedItemUrl = getRemovedCartItemUrl(this);
      const cartState = await cartItems.updateQuantity(
        this.dataset.index,
        0,
        null,
        null,
      );
      await this._cleanupOrphanAddons(cartItems, cartState);

      if (cartState && !cartState.errors) {
        showCartRemovalToast(cartItems, removedItemTitle, removedItemUrl);
      }
    }

    async _fetchCartState() {
      return fetchCartState();
    }

    async _cleanupOrphanAddons(cartItems, state = null) {
      try {
        const cartContents = state || (await this._fetchCartState());

        if (!cartContents || !cartContents.items?.length) {
          return;
        }

        const variantIds = new Set(
          cartContents.items.map((item) => item.variant_id),
        );
        const orphanItems = cartContents.items.filter(
          (item) =>
            item.properties?._for_product &&
            !variantIds.has(Number(item.properties._for_product)),
        );

        if (!orphanItems.length) {
          await checkIfOnlyItemsLeftAreAddons(cartContents, cartItems);
          return;
        }

        const updates = orphanItems.reduce((acc, item) => {
          acc[item.key] = 0;
          return acc;
        }, {});

        const updateUrl =
          typeof routes !== "undefined" && routes.cart_update_url
            ? routes.cart_update_url
            : window.Shopify.routes.root + "cart/update.js";
        const cart = await cartItems._sendCartRequest(updateUrl, {
          updates,
        });
        cartItems._applyCartSnapshot(cart);

        await checkIfOnlyItemsLeftAreAddons(cart, cartItems);
      } catch (error) {
        console.error("Error updating cart:", error);
      }
    }
  }

  customElements.define("cart-remove-button", CartRemoveButton);
}

if (!customElements.get("cart-items")) {
  class CartItems extends HTMLElement {
    constructor() {
      super();
      this.lineItemStatusElement =
        document.getElementById("shopping-cart-line-item-status") ||
        document.getElementById("CartDrawer-LineItemStatus");

      const debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, ON_CHANGE_DEBOUNCE_TIMER);

      this.addEventListener("change", debouncedOnChange);
      this.renderedSectionsCache = new Map();
      this.addonModalContentCache = new Map();
      this.addonModalRequestCache = new Map();
      this.modalPageContentCache = new Map();
      this.modalPageRequestCache = new Map();
      this.latestQuantityRequestIds = new Map();
      this.quantityRequestCounter = 0;
      this.isWaitingForAddonUpdates = false;
      this._handleLearnMoreClick = this._handleLearnMoreClick.bind(this);
      this._handleStickySidebarResize =
        this._handleStickySidebarResize.bind(this);
      this._handleSubmit = this._handleSubmit.bind(this);

      this.addEventListener("click", this._handleLearnMoreClick);
      this.addEventListener("submit", this._handleSubmit);
      this._hydratePreopenSlider();
    }

    cartUpdateUnsubscriber = undefined;

    connectedCallback() {
      window.addEventListener("resize", this._handleStickySidebarResize);
      this._scheduleStickySidebarSync();

      this.cartUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.cartUpdate,
        (event) => {
          if (event.source === "cart-items") {
            return;
          }
          this.onCartUpdate(event);
        },
      );
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this._handleStickySidebarResize);
      this.stickySidebarResizeObserver?.disconnect();
      if (this.stickySidebarFrame) {
        cancelAnimationFrame(this.stickySidebarFrame);
      }
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      this.removeEventListener("submit", this._handleSubmit);
    }

    onChange(event) {
      if (
        event.target?.classList?.contains("addons-inputs") ||
        event.target?.closest("cart-addon-selector") ||
        event.target.type === "checkbox"
      ) {
        return;
      }
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId,
      );
    }

    async onCartUpdate(event) {
      const cartState = event?.cartData;
      if (cartState && cartState.sections) {
        this._applyCartSnapshot(cartState);
        return cartState;
      }

      const sectionId =
        this.tagName === "CART-DRAWER-ITEMS"
          ? "cart-drawer"
          : "main-cart-items";

      return fetchText(`${routes.cart_url}?section_id=${sectionId}`)
        .then((responseText) => {
          const html = parseHtml(responseText);

          if (sectionId === "cart-drawer") {
            const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.innerHTML = sourceElement.innerHTML;
              }
            }
          } else {
            const sourceQty = html.querySelector("cart-items");
            if (sourceQty) {
              this.innerHTML = sourceQty.innerHTML;
            }
          }

          this._hydratePreopenSlider();
          refreshAffirmPromos();
          return html;
        })
        .catch((e) => {
          console.error(e);
          return null;
        });
    }

    async _handleSubmit(event) {
      const submitter = event.submitter;
      if (this.isWaitingForAddonUpdates || submitter?.name !== "checkout") {
        return;
      }

      const collectPendingAddonUpdates = () =>
        [...this.querySelectorAll("cart-addon-selector")]
          .map((selector) => selector.updatePromise)
          .filter(Boolean);

      if (!collectPendingAddonUpdates().length) {
        return;
      }

      event.preventDefault();
      this.isWaitingForAddonUpdates = true;
      submitter?.setAttribute("aria-disabled", "true");

      try {
        // Drain in a loop: a new addon update may start while we're awaiting
        // the current batch, and we must not submit while any mutation is in
        // flight.
        let pending = collectPendingAddonUpdates();
        while (pending.length) {
          await Promise.allSettled(pending);
          pending = collectPendingAddonUpdates();
        }
        // requestSubmit fires `submit` synchronously and reenters this handler;
        // isWaitingForAddonUpdates must stay true so the reentry short-circuits
        // and lets the native submission proceed.
        event.target.requestSubmit(submitter);
      } finally {
        this.isWaitingForAddonUpdates = false;
        submitter?.removeAttribute("aria-disabled");
      }
    }

    getSectionsToRender() {
      const mainCartItems = document.getElementById("main-cart-items");
      const mainCartFooter = document.getElementById("main-cart-footer");
      const sections = [
        {
          id: "main-cart-items",
          section: mainCartItems?.dataset?.id,
          selector: ".js-contents",
        },
        {
          id: "main-cart-items",
          section: mainCartItems?.dataset?.id,
          selector: "[data-cart-heading]",
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".shopify-section",
        },
        {
          id: "cart-live-region-text",
          section: "cart-live-region-text",
          selector: ".shopify-section",
        },
        {
          id: "main-cart-footer",
          section: mainCartFooter?.dataset?.id,
          selector: ".js-contents",
        },
      ].filter((section) => section.id && section.section);

      // Add motivator section if it exists
      const motivatorElement = document.getElementById("motivator");
      if (motivatorElement && motivatorElement.dataset?.id) {
        const sectionWrapper = motivatorElement.closest(
          '[id^="shopify-section-"]',
        );
        if (sectionWrapper) {
          sections.push({
            id: sectionWrapper.id,
            section: motivatorElement.dataset.id,
            selector: "#motivator",
          });
        }
      }

      return sections;
    }

    async updateQuantity(line, quantity, name, variantId) {
      const requestId = ++this.quantityRequestCounter;
      this.latestQuantityRequestIds.set(String(line), requestId);
      this.enableLoading(line);

      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);
      const itemsBeforeUpdate = document.querySelectorAll(".cart-item");

      try {
        const changeUrl =
          typeof routes !== "undefined" && routes.cart_change_url
            ? routes.cart_change_url
            : window.Shopify.routes.root + "cart/change.js";
        const parsedState = await this._sendCartRequest(changeUrl, {
          line,
          quantity,
        });

        if (this.latestQuantityRequestIds.get(String(line)) !== requestId) {
          return parsedState;
        }

        if (parsedState.errors) {
          if (quantityElement) {
            quantityElement.value = quantityElement.getAttribute("value");
          }
          this.updateLiveRegions(line, parsedState.errors);
          return parsedState;
        }

        this._applyCartState({
          line,
          name,
          variantId,
          quantityElement,
          itemsBeforeUpdate,
          state: parsedState,
        });
        return parsedState;
      } catch (error) {
        if (this.latestQuantityRequestIds.get(String(line)) !== requestId) {
          return null;
        }
        this._handleCartRequestError(error);
        return null;
      } finally {
        if (this.latestQuantityRequestIds.get(String(line)) === requestId) {
          this.latestQuantityRequestIds.delete(String(line));
          this.disableLoading(line);
        }
      }
    }

    _applyCartState({
      line,
      name,
      variantId,
      quantityElement,
      itemsBeforeUpdate,
      state,
    }) {
      if (!state) {
        return;
      }

      this._syncEmptyState(state);

      this._renderSectionsFromState(state);

      const updatedLineItem = state.items ? state.items[line - 1] : undefined;
      const updatedValue = updatedLineItem
        ? updatedLineItem.quantity
        : undefined;
      let message = "";

      if (
        quantityElement &&
        itemsBeforeUpdate.length === state.items.length &&
        updatedValue !== parseInt(quantityElement.value, 10)
      ) {
        if (typeof updatedValue === "undefined") {
          message = window.cartStrings.error;
        } else {
          message = window.cartStrings.quantityError.replace(
            "[quantity]",
            updatedValue,
          );
        }
      }

      this.updateLiveRegions(line, message);

      const lineItem =
        document.getElementById(`CartItem-${line}`) ||
        document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        lineItem.querySelector(`[name="${name}"]`).focus();
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items",
        cartData: state,
        variantId,
      });
    }

    _applyCartSnapshot(state) {
      if (!state) {
        return;
      }

      this._syncEmptyState(state);
      this._renderSectionsFromState(state);

      if (typeof publish === "function") {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: state,
        });
      }
    }

    _syncEmptyState(state) {
      const isEmpty = state?.item_count === 0;

      this.classList.toggle("is-empty", isEmpty);
      const cartFooter = document.getElementById("main-cart-footer");
      const emptyState = this.querySelector("[data-cart-empty-state]");
      const emptyCategories = this.querySelector(
        "[data-cart-empty-categories]",
      );
      const cartHeading = this.querySelector("[data-cart-heading]");

      if (cartFooter) {
        cartFooter.classList.toggle("is-empty", isEmpty);
      }

      if (emptyState) {
        emptyState.classList.toggle("hidden", !isEmpty);
      }
      if (emptyCategories) {
        emptyCategories.classList.toggle("hidden", !isEmpty);
      }
      if (cartHeading) {
        cartHeading.classList.remove("hidden");
      }
    }

    _renderSectionsFromState(state) {
      if (!state || !state.sections) {
        return;
      }

      const openAddonCards = this._getOpenAddonCardKeys();
      const sections = this.getSectionsToRender();
      const parsedSections = new Map();
      sections.forEach((section) => {
        if (section.render === false) {
          return;
        }

        const container = section.id
          ? document.getElementById(section.id)
          : null;
        if (!container) {
          return;
        }

        const sectionHtml = state.sections[section.section];
        if (!sectionHtml) {
          return;
        }

        const sectionCacheKey = `${section.section}:${section.selector || ""}`;
        if (this.renderedSectionsCache.get(sectionCacheKey) === sectionHtml) {
          return;
        }

        let parsedSection = parsedSections.get(section.section);
        if (!parsedSection) {
          parsedSection = parseHtml(sectionHtml);
          parsedSections.set(section.section, parsedSection);
        }

        let target = container;
        if (section.selector) {
          const inner = container.querySelector(section.selector);
          if (inner) {
            target = inner;
          } else if (container.matches && container.matches(section.selector)) {
            target = container;
          }
        }

        const source = section.selector
          ? parsedSection.querySelector(section.selector)
          : parsedSection.body;
        if (!source) {
          return;
        }

        const innerHTML = source.innerHTML;
        if (typeof innerHTML === "string" && target.innerHTML !== innerHTML) {
          target.innerHTML = innerHTML;
        }
        this.renderedSectionsCache.set(sectionCacheKey, sectionHtml);
      });

      this._restoreOpenAddonCards(openAddonCards);
      this._hydratePreopenSlider();
      this._scheduleStickySidebarSync();
      refreshAffirmPromos();
    }

    _getAddonCardKey(details) {
      const cartItemId = details.closest(".cart-item")?.id || "";

      if (details.matches(".cart-addon-card--warranty")) {
        const addonKey = details.closest("[data-id]")?.dataset.id || cartItemId;
        return addonKey ? `${addonKey}:warranty` : "";
      }

      if (details.matches(".cart-page__service-card")) {
        const addonKey =
          details.querySelector("[data-id]")?.dataset.id || cartItemId;
        return addonKey ? `${addonKey}:services` : "";
      }

      return "";
    }

    _getOpenAddonCardKeys() {
      return new Set(
        [
          ...this.querySelectorAll(
            ".cart-addon-card[open], .cart-page__service-card[open]",
          ),
        ]
          .map((details) => this._getAddonCardKey(details))
          .filter(Boolean),
      );
    }

    _restoreOpenAddonCards(openAddonCards) {
      if (!openAddonCards?.size) {
        return;
      }

      this.querySelectorAll(
        ".cart-addon-card, .cart-page__service-card",
      ).forEach((details) => {
        if (openAddonCards.has(this._getAddonCardKey(details))) {
          details.open = true;
        }
      });
    }

    _handleStickySidebarResize() {
      this._scheduleStickySidebarSync();
    }

    _scheduleStickySidebarSync() {
      if (this.stickySidebarFrame) {
        cancelAnimationFrame(this.stickySidebarFrame);
      }

      this.stickySidebarFrame = requestAnimationFrame(() => {
        this.stickySidebarFrame = null;
        this._syncStickySidebarOffset();
      });
    }

    _syncStickySidebarOffset() {
      const sidebarContainer = this.querySelector(
        ".cart-page__sidebar-container",
      );
      const checkoutButton = this.querySelector(".cart-page__checkout-button");

      if (!sidebarContainer || !checkoutButton) {
        this.stickySidebarResizeObserver?.disconnect();
        this.stickySidebarElement = null;
        return;
      }

      if (
        window.ResizeObserver &&
        this.stickySidebarElement !== sidebarContainer
      ) {
        this.stickySidebarResizeObserver?.disconnect();
        this.stickySidebarResizeObserver = new ResizeObserver(() => {
          this._scheduleStickySidebarSync();
        });
        this.stickySidebarResizeObserver.observe(sidebarContainer);
        this.stickySidebarElement = sidebarContainer;
      }

      if (window.innerWidth >= 1024) {
        sidebarContainer.style.bottom = "";
        return;
      }

      const containerRect = sidebarContainer.getBoundingClientRect();
      const checkoutRect = checkoutButton.getBoundingClientRect();
      const contentBelowCheckout =
        containerRect.bottom -
        checkoutRect.bottom -
        STICKY_SIDEBAR_CHECKOUT_OFFSET;

      sidebarContainer.style.bottom =
        contentBelowCheckout > 0 ? `-${contentBelowCheckout}px` : "0px";
    }

    _buildCartRequestBody(payload = {}) {
      const payloadSections = Array.isArray(payload.sections)
        ? payload.sections.filter(Boolean)
        : null;
      const sections = this._getUniqueSectionIds(
        payloadSections ||
          this.getSectionsToRender().map((section) => section.section),
      );

      const { sections: _ignored, ...restPayload } = payload;

      return JSON.stringify({
        sections,
        sections_url: this._getSectionsUrl(),
        ...restPayload,
      });
    }

    async _sendCartRequest(url, payload = {}) {
      const options = {
        ...fetchConfig(),
        body: this._buildCartRequestBody(payload),
      };
      return fetchJson(url, options);
    }

    _getUniqueSectionIds(sections) {
      return [...new Set(sections.filter(Boolean))];
    }

    _getSectionsUrl() {
      if (CartItems.sectionsUrlCache) {
        return CartItems.sectionsUrlCache;
      }

      const defaultUrl = routes?.cart_url || "/cart";

      // If the current page is already the cart template, reuse its pathname so
      // Shopify respects locale prefixes or alternate carts.
      if (
        window.location.pathname === defaultUrl ||
        document.getElementById("main-cart-items")
      ) {
        CartItems.sectionsUrlCache = window.location.pathname;
        return CartItems.sectionsUrlCache;
      }

      CartItems.sectionsUrlCache = defaultUrl;
      return CartItems.sectionsUrlCache;
    }

    _handleCartRequestError(error) {
      this.querySelectorAll(".loading__spinner").forEach((overlay) =>
        overlay.classList.add("hidden"),
      );
      const errors =
        document.getElementById("cart-errors") ||
        document.getElementById("CartDrawer-CartErrors");
      if (errors) {
        errors.textContent = window.cartStrings.error;
      }
      console.error("Error updating cart:", error);
    }

    updateLiveRegions(line, message) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      const lineItemErrorText = lineItemError?.querySelector(
        ".cart-item__error-text",
      );
      if (lineItemErrorText) {
        lineItemErrorText.innerHTML = message;
      }

      this.lineItemStatusElement?.setAttribute("aria-hidden", true);

      const cartStatus =
        document.getElementById("cart-live-region-text") ||
        document.getElementById("CartDrawer-LiveRegionText");
      if (!cartStatus) {
        return;
      }

      cartStatus.setAttribute("aria-hidden", false);

      setTimeout(() => {
        cartStatus.setAttribute("aria-hidden", true);
      }, 1000);
    }

    enableLoading(line) {
      const mainCartItems =
        document.getElementById("main-cart-items") ||
        document.getElementById("CartDrawer-CartItems");
      mainCartItems?.classList.add("cart__items--disabled");

      const cartItemElements = this.querySelectorAll(
        `#CartItem-${line} .loading__spinner`,
      );
      const cartDrawerItemElements = this.querySelectorAll(
        `#CartDrawer-Item-${line} .loading__spinner`,
      );

      [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
        overlay.classList.remove("hidden"),
      );

      document.activeElement?.blur();
      this.lineItemStatusElement?.setAttribute("aria-hidden", false);
    }

    disableLoading(line) {
      const mainCartItems =
        document.getElementById("main-cart-items") ||
        document.getElementById("CartDrawer-CartItems");
      mainCartItems?.classList.remove("cart__items--disabled");

      const cartItemElements = this.querySelectorAll(
        `#CartItem-${line} .loading__spinner`,
      );
      const cartDrawerItemElements = this.querySelectorAll(
        `#CartDrawer-Item-${line} .loading__spinner`,
      );

      cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
      cartDrawerItemElements.forEach((overlay) =>
        overlay.classList.add("hidden"),
      );
    }

    async _handleLearnMoreClick(event) {
      const trigger = event.target?.closest?.("a.option--learn-more");
      if (!trigger || !this.contains(trigger)) {
        return;
      }

      event.preventDefault();
      const modalHtml = await this._getModalContent(trigger);
      if (modalHtml) {
        this.showAddonModal(modalHtml);
      }
    }

    _hydratePreopenSlider() {
      const preopenSlider = document.querySelector("slider-container.open");
      if (
        preopenSlider &&
        !preopenSlider.querySelector(".sc__content")?.innerHTML
      ) {
        this._getModalContent().then((modalHtml) => {
          if (modalHtml) {
            this.showAddonModal(modalHtml);
          }
        });
      }
    }

    async _getModalContent(triggerEl = null) {
      const inlineHtml = triggerEl?.dataset?.modalHtml;
      if (inlineHtml) return inlineHtml;

      const href = triggerEl?.getAttribute("href");
      const modalUrl = triggerEl?.dataset?.modalUrl;

      // Remove the hardcoded link once the warranty page has been implemented to align with 'addon-modal'
      if (
        triggerEl?.getAttribute("href") == "/pages/delivery-and-installation"
      ) {
        try {
          if (modalUrl && this.addonModalContentCache.has(modalUrl)) {
            return this.addonModalContentCache.get(modalUrl);
          }

          if (modalUrl) {
            if (!this.addonModalRequestCache.has(modalUrl)) {
              this.addonModalRequestCache.set(
                modalUrl,
                fetchText(modalUrl).finally(() => {
                  this.addonModalRequestCache.delete(modalUrl);
                }),
              );
            }

            const modalHtml = await this.addonModalRequestCache.get(modalUrl);
            if (modalHtml?.trim()) {
              this.addonModalContentCache.set(modalUrl, modalHtml);
              return modalHtml;
            }
          }
        } catch (error) {
          console.error("Error fetching addon modal content:", error);
        }
      }

      // Fetch the page content of the link
      try {
        if (href && this.modalPageContentCache.has(href)) {
          const cachedMainContent = this.modalPageContentCache.get(href);
          const slider = document.querySelector("slider-container");
          if (!slider) {
            return null;
          }

          slider.fillContent(cachedMainContent);
          slider.open();
          return null;
        }

        if (href && !this.modalPageRequestCache.has(href)) {
          this.modalPageRequestCache.set(
            href,
            fetchText(href).finally(() => {
              this.modalPageRequestCache.delete(href);
            }),
          );
        }

        const pageContent = href
          ? await this.modalPageRequestCache.get(href)
          : null;
        if (!pageContent) {
          return null;
        }

        const doc = parseHtml(pageContent);
        const mainContent =
          doc.querySelector("main")?.innerHTML ||
          "<p>Main content not found</p>";
        if (href) {
          this.modalPageContentCache.set(href, mainContent);
        }

        // Display the <main> content in the div with id="main-content"
        const slider = document.querySelector("slider-container");
        if (!slider) {
          return null;
        }

        slider.fillContent(mainContent);
        slider.open();
      } catch (error) {
        console.error("Error fetching page content:", error);
      }

      return null;
    }

    async showAddonModal(modalHtml) {
      const slider = document.querySelector("slider-container");
      if (!slider) {
        console.error("slider-container not found");
        return;
      }

      if (!modalHtml) {
        console.error("No modal content provided");
        return;
      }

      slider.fillContent(modalHtml);
      // Open after content is injected to ensure layout is ready
      requestAnimationFrame(() => {
        slider.open();
      });
    }
  }

  CartItems.sectionsUrlCache = null;

  customElements.define("cart-items", CartItems);
  customElements.define("cart-drawer-items", CartItems);
}

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
}

document.addEventListener("DOMContentLoaded", () => {
  const cartRoot = document.querySelector("cart-items");
  if (!cartRoot) {
    return;
  }

  const getAddonPopoverRow = (target) =>
    target instanceof Element
      ? target.closest(".cart-items__heading--addon")
      : null;

  cartRoot.addEventListener("mouseover", (event) => {
    const row = getAddonPopoverRow(event.target);
    row?.querySelector(".cart-addon-popover")?.classList.add("show");
  });

  cartRoot.addEventListener("click", (event) => {
    const activeRow = getAddonPopoverRow(event.target);

    document.querySelectorAll(".cart-addon-popover.show").forEach((popover) => {
      const row = popover.closest(".cart-items__heading--addon");
      if (row !== activeRow) {
        popover.classList.remove("show");
      }
    });

    activeRow?.querySelector(".cart-addon-popover")?.classList.add("show");
  });

  cartRoot.addEventListener("mouseout", (event) => {
    const row = getAddonPopoverRow(event.target);
    const relatedRow = getAddonPopoverRow(event.relatedTarget);
    if (row && row !== relatedRow) {
      row.querySelector(".cart-addon-popover")?.classList.remove("show");
    }
  });

  document.addEventListener("click", (event) => {
    if (!cartRoot.contains(event.target)) {
      cartRoot
        .querySelectorAll(".cart-addon-popover.show")
        .forEach((popover) => {
          popover.classList.remove("show");
        });
    }
  });
});
